const SORTED_FIELDS = [
    'buisnessProcess', 'serviceClass', 'contact', 'project', 'role', 'assignee', 'dateStart',
    'deadline', 'dateCreate', 'dateComplete', 'observers', 'priority', 'itservice', 'owner',
];

export default SORTED_FIELDS;
